import { HeaderPage } from "../../../components/header-page/HeaderPage";

export const ShippingCostHeader = () => {
  return <HeaderPage title="Costos de envío" />;
};
